import React from 'react'
import { Button } from "@mui/material";

const ExpandBtn = ({handle, IMG_SRC}) => {
    return (
        <Button onClick={handle}>
            <img 
                src={IMG_SRC} 
                style={{ width: '42px', ºheight: '42px' }} 
                alt={"Abrir en imagen"} 
            />
        </Button>
    );
}

export default ExpandBtn;